import { useContext } from 'react';
import { Title } from '../shared/title/title.tsx';
import './bio.css';
import hmtBio from './bio.json';
import { LanguageContext } from '../../contexts/languageContext.tsx';

function Bio() {
    const language:string= useContext(LanguageContext) ;

    const text: string = hmtBio[language as "en"|"it"];
    return (
        <div id='bio' className="animated">
            <Title value='Bio' />
            <div id='bio-container'>
                <div id='bio-img'>
                </div>
                <div
                    id="bio-text"
                >
                    <h1><b>HOLD ME TIGHT</b></h1>
                    <p dangerouslySetInnerHTML={{__html: text}}></p>
                </div>
            </div>

        </div>
    )
}

export { Bio };